(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('production-unit', {
            parent: 'company_admin',
            url: '/production-unit?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productionUnit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/production-unit/production-units.html',
                    controller: 'ProductionUnitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: '(name),asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productionUnit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('production-unit-detail', {
            parent: 'company_admin',
            url: '/production-unit/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.productionUnit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/production-unit/production-unit-detail.html',
                    controller: 'ProductionUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('productionUnit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProductionUnit', function($stateParams, ProductionUnit) {
                    return ProductionUnit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'production-unit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('production-unit-detail.edit', {
            parent: 'production-unit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('production-unit.new', {
            parent: 'production-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('production-unit');
                });
            }]
        })
        .state('production-unit.edit', {
            parent: 'production-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-dialog.html',
                    controller: 'ProductionUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('production-unit.delete', {
            parent: 'production-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/production-unit/production-unit-delete-dialog.html',
                    controller: 'ProductionUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProductionUnit', function(ProductionUnit) {
                            return ProductionUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('production-unit', null, { reload: 'production-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
